module.exports = __webpack_public_path__ + "static/media/Celeb4.69757c0c.jpg";